// extracted by mini-css-extract-plugin
export default {"fillbutton":"fill_fillbutton__9dKHV","wrong":"fill_wrong__qLIvE","shake":"fill_shake__OVS3a"};